/**
 * App config consumed in browser/runtime code.
 * Keep this list explicit so environment usage stays discoverable.
 */

const sanitizeURL = (url?: string): string => {
  if (!url) return "";

  try {
    return new URL(url).toString().replace(/\/$/, "");
  } catch {
    return "";
  }
};

const env = ((import.meta as any).env ?? {}) as Record<
  string,
  string | undefined
>;

const appConfig = {
  NODE_ENV: env.MODE || "development",
  BACKEND_URL: sanitizeURL(env.VITE_BACKEND_URL),
  CI_COMMIT_SHA: env.VITE_CI_COMMIT_SHA,
  SENTRY_DSN: env.VITE_SENTRY_DSN,
  MIXPANEL_TOKEN: env.VITE_MIXPANEL_TOKEN,
  ADJUST_APP_TOKEN: env.VITE_ADJUST_APP_TOKEN,
  TURNSTILE_SITE_KEY: env.VITE_TURNSTILE_SITE_KEY,
  /** Google Ad Manager ad unit path used for every provider="gam" slot. */
  GAM_AD_UNIT: env.VITE_GAM_AD_UNIT?.trim() || undefined,
  GAM_DEBUG: env.VITE_GAM_DEBUG === "true",
} as const;

export default appConfig;
